import api from "@/api";
import { JSConn } from "@/utilities/js-conn";

export interface WorkOrderNote {
  id: string;
  content_json: {
    type: string;
    content: any[];
  };
  created_at: string;
  user_id: string;
  user: string;
  work_order_id?: string;
  work_order_name?: string;
  work_order?: string;
  work_order_description?: string;
  client_field?: string;
  client_field_id?: string;
}

interface WorkOrderNoteState {
  workOrderNote: WorkOrderNote | {};
  workOrderNotes: WorkOrderNote[];
}

const itemDetails = {
  pluralName: "work_order_notes",
  singularName: "work_order_note",
};

const apiParamsBuilder = (jsConn: JSConn) => {
  return {
    id: jsConn.formParams.id,
    work_order_note: {
      ...jsConn.formParams,
    },
  };
};

const state: WorkOrderNoteState = {
  workOrderNote: {},
  workOrderNotes: [],
};

const mutations = {
  LOAD_WORK_ORDER_NOTE(state: WorkOrderNoteState, payload: WorkOrderNote) {
    state.workOrderNote = payload;
  },
  LOAD_WORK_ORDER_NOTES(state: WorkOrderNoteState, payload: WorkOrderNote[]) {
    state.workOrderNotes = payload;
  },
};

const actions = {
  needWorkOrderNotes(context: any, jsConn: JSConn) {
    jsConn.apiParams = jsConn.formParams;
    return api.getItems(jsConn, itemDetails).then((jsConn: JSConn) => {
      context.commit("LOAD_WORK_ORDER_NOTES", jsConn.response);
      return Promise.resolve(jsConn);
    });
  },
  createWorkOrderNote(context: any, jsConn: JSConn) {
    jsConn.apiParams = apiParamsBuilder(jsConn);
    return api
      .createItem(jsConn, itemDetails)
      .then((jsConn: JSConn) => {
        context.commit("LOAD_WORK_ORDER_NOTE", jsConn.response);
        return Promise.resolve(jsConn);
      })
      .catch((jsConn: JSConn) => {
        return Promise.reject(jsConn);
      });
  },
};

const getters = {
  workOrderNotes: (state: WorkOrderNoteState) => {
    return state.workOrderNotes;
  },
  workOrderNotesCount: (state: WorkOrderNoteState) => {
    return state.workOrderNotes.length;
  },
};

const workOrderNotesModule = {
  state,
  mutations,
  actions,
  getters,
};

export default workOrderNotesModule;
